import React from 'react';
import { View } from 'react-native';

import Item from './components/item';
import Loading, { SmallLoading } from '@components/loading';
import Refresh from '@components/common/Refresh';

import { isPhone, calculateTableConfig, deepClone } from '@helpers';
import { scale, fullWidth } from '@components/frame';
import { TILE_CONFIG } from '@v2/pages/common/constants/base.constants';
import DataGrid from '@components/common/DataGrid';
import { updateImageMetadata } from '@reducers/imageHandling';
import { connect } from 'react-redux';

import Image from '@v2/context/Image/context';

import { SCREEN_PADDING_HORIZONTAL, TABLE_NAMES, TEST_IDS } from '@v2/pages/common/constants/base.constants';
import { useDeviceSize } from '@v2/pages/common/hooks/useDeviceSize';
import { DOCUMENT_ENTITY_TYPE, IMAGE_HANDLING_CONTEXT } from '@components/imageHandling/common';
import { LevelSubScreen } from '@v2/pages/common/enums';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { handleOpen, getDataGridColumns } from './helpers';

const ProductionOrders = (props) => {
  const {
    totalSearchResult,
    searchResult,
    isError,
    loaded,
    C,
    isSmallMode,
    isLineMode,
    isTableMode,
    fetchData,
    generateImageURL,
    recentlyViewed,
    setRecentlyViewed,
    attachMode,
    attachImageId,
    updateImageMetadata,
    onItemSelect,
    isPopupMode,
    popupWidth,
  } = props;

  const { IS_NARROW_WEB } = useDeviceSize();

  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();

  const effectiveWidth = isPopupMode && popupWidth ? popupWidth : fullWidth;

  const open = (item, levelSubScreen = LevelSubScreen.GENERAL) => {
    handleOpen({
      item,
      levelSubScreen,
      isPopupMode,
      onItemSelect,
      attachMode,
      attachImageId,
      updateImageMetadata,
      navigateToMainDetailsScreen,
    });
  };

  const renderImageCell = (item) => {
    const imgSize = { width: scale(50), height: scale(30) };

    const imageData = {
      image: {
        documentId: item.imageDocumentId,
        imageHash: item.imageHash,
        imageData: {
          isCropped: item.imageData?.isCropped,
          extensionDerivative: item.imageData?.extensionDerivative,
          pageNumber: item.imageData?.pageNumber,
          rotationAngle: item.imageData?.rotationAngle || 0,
          rotationAngleCrop: item.imageData?.rotationAngle || 0,
        },
        width: imgSize.width,
        height: imgSize.height,
        contextId: item.productionOrderId,
        contextCode: IMAGE_HANDLING_CONTEXT[DOCUMENT_ENTITY_TYPE.ProductionOrder],
      },
      onPress: () => open(item, LevelSubScreen.DOCUMENTS),
    };

    return (
      <View
        testID={TEST_IDS.searchScreen.productionOrders.dataGridImage}
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}
      >
        <Image {...imageData} attachMode={attachMode} />
      </View>
    );
  };

  const dataGridColumns = getDataGridColumns(open, renderImageCell);

  const config = {
    width: effectiveWidth,
    scale,
    initialBaseSize: isSmallMode ? TILE_CONFIG.BASE_WIDTH_SMALL : TILE_CONFIG.BASE_WIDTH,
    spaceBetween: isSmallMode ? TILE_CONFIG.SPACE_BETWEEN_SMALL : TILE_CONFIG.SPACE_BETWEEN_NORMAL,
  };
  const { columns, itemSize } = calculateTableConfig(config);

  const data = deepClone(searchResult);

  const additions = columns - (data.length % columns);
  if (additions !== columns) {
    for (let i = 0; i < additions; i++) {
      data.push('empty');
    }
  }

  if (isTableMode) {
    return (
      <View testID={TEST_IDS.searchScreen.productionOrders.dataGridContainer} style={{ width: effectiveWidth, flex: 1 }}>
        <DataGrid
          {...{
            ...props,
            primaryKey: 'productionOrderNumber',
            onRowClick: open,
            columns: dataGridColumns,
            data,
            idName: 'productionOrderId',
            tableName: props.tableName || TABLE_NAMES.productionOrder,
          }}
        />
      </View>
    );
  }

  if (isError) {
    return <Refresh onPress={fetchData} />;
  }

  return (
    <View style={{ width: effectiveWidth, height: '100%' }}>
      {loaded ? (
        <View>
          <View
            testID={TEST_IDS.searchScreen.productionOrders.itemContainer}
            style={[
              {
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                marginTop: scale(IS_NARROW_WEB ? 11 : isPhone ? -9 : -5),
                justifyContent: 'space-between',
                flexDirection: 'row',
                flexWrap: 'wrap',
                paddingHorizontal: scale(isPopupMode ? 20 : SCREEN_PADDING_HORIZONTAL),
              },
              isLineMode && { marginTop: 0 },
            ]}
          >
            {data.map((item, index) => (
              <Item
                key={'Item' + index}
                item={item}
                {...{
                  index,
                  itemSize,
                  generateImageURL,
                  isSmallMode,
                  isLineMode,
                  recentlyViewed,
                  setRecentlyViewed,
                  open,
                  attachMode,
                  attachImageId,
                  effectiveWidth,
                  isPopupMode,
                }}
                isEmpty={item === 'empty'}
              />
            ))}
          </View>
          {totalSearchResult !== searchResult?.length && (
            <View
              style={{
                marginTop: scale(20),
                backgroundColor: C('Background / Light / System'),
                justifyContent: 'center',
              }}
            >
              <SmallLoading />
            </View>
          )}
        </View>
      ) : (
        <Loading />
      )}
    </View>
  );
};

export default connect(null, { updateImageMetadata })(ProductionOrders);
